export default __webpack_public_path__ + "static/media/logo (1).72b6f953.png";